import { ImpressumPage } from "@features/impressum/ImpressumPage.tsx";
import { PrivacyPage } from "@features/privacy/PrivacyPage.tsx";
import { AgbPage } from "@features/agb/AgbPage.tsx";
import { DisclaimerPage } from "@features/disclaimer/DisclaimerPage.tsx";
import React from "react";
import { RouteWithRedirect } from "../routes.tsx";

export default [
  {
    path: "impressum",
    element: (
      <RouteWithRedirect type="impressum">
        <ImpressumPage />
      </RouteWithRedirect>
    ),
  },
  {
    path: "privacy",
    element: (
      <RouteWithRedirect type="privacy">
        <PrivacyPage />
      </RouteWithRedirect>
    ),
  },
  {
    path: "agb",
    element: (
      <RouteWithRedirect type="agb">
        <AgbPage />
      </RouteWithRedirect>
    ),
  },
  {
    path: "disclaimer",
    element: (
      <RouteWithRedirect type="disclaimer">
        <DisclaimerPage />
      </RouteWithRedirect>
    ),
  },
];
